import React, { FC } from 'react';
import { AvatarColors, User } from 'models/User';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { SIZE, Size } from 'models/Size';
import { XOR } from 'types';

import './AvatarWithInitials.styles.scss';

type AvatarWithInitialsProps = {
  className?: string;
  size?: Size;
} & XOR<
  { user: Partial<User> },
  { imageUrl?: string; initials?: string; color?: AvatarColors }
>;

const AvatarWithInitials: FC<AvatarWithInitialsProps> = ({
  className,
  user,
  initials,
  color,
  imageUrl,
  size = SIZE.SMALL,
}) => {
  const { firstName, lastName, profileImage, avatarColor } = user || {};

  const avatarUrl = profileImage?.url || imageUrl;
  const hasAvatarLogo = avatarUrl || (!firstName && !lastName && !initials);

  const classses = classNames(
    'avatar-with-initials',
    `avatar-with-initials--${size}`,
    color || avatarColor,
    className,
  );

  return hasAvatarLogo ? (
    <ResolveImage
      asAvatar
      className={classses}
      src={getImgUrl(avatarUrl, '100')}
    />
  ) : (
    <span className={classNames(classses, 'initials')}>
      {initials ? (
        initials
      ) : (
        <>
          {firstName?.[0]}
          {lastName?.[0]}
        </>
      )}
    </span>
  );
};

export default AvatarWithInitials;
